"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TadaGPTEditor;
var _react = _interopRequireWildcard(require("react"));
var _ej2Base = require("@syncfusion/ej2-base");
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _ej2ReactRichtexteditor = require("@syncfusion/ej2-react-richtexteditor");
require("@syncfusion/ej2-base/styles/material.css");
require("@syncfusion/ej2-inputs/styles/material.css");
require("@syncfusion/ej2-react-richtexteditor/styles/material.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(0, _ej2Base.registerLicense)('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9ec3VXR2BZVkB1X0o=');
function TadaGPTEditor({
  editorHeight,
  setEditorHeight,
  editorRef,
  value,
  onChange,
  placeholder,
  onHandleSubmit,
  autofocus = true,
  endAdornment = null,
  onArrowDown,
  onArrowUp,
  onEnter,
  onEscape,
  suggestions,
  selectedSuggestionIndex
}) {
  const [isClient, setIsClient] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsClient(true);
  }, []);
  const handleChange = e => {
    if (onChange) {
      onChange(e.value);
    }
  };
  const handleActionBegin = (0, _react.useCallback)(e => {
    if (e.requestType === 'EnterAction') {
      e.cancel = true;
      if (onHandleSubmit) {
        onHandleSubmit();
      }
    }
  }, [onHandleSubmit]);
  const adjustHeight = () => {
    const editorElement = editorRef.current?.element;
    if (editorElement) {
      const contentElement = editorElement.querySelector('.e-rte-content');
      if (contentElement) {
        const contentHeight = contentElement.scrollHeight;
        const newHeight = Math.max(51, Math.min(contentHeight, 92));
        setEditorHeight(newHeight);
      }
    }
  };
  (0, _react.useEffect)(() => {
    const editor = editorRef?.current;
    if (editor && autofocus) {
      editor.focusIn();
    }
    if (editor) {
      const handleKeyDown = e => {
        if (e.key === 'Enter') e.preventDefault();
      };
      editor.element.addEventListener('keydown', handleKeyDown);
      adjustHeight();
      const observer = new MutationObserver(adjustHeight);
      const contentElement = editor.element.querySelector('.e-rte-content');
      if (contentElement) {
        observer.observe(contentElement, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      return () => {
        editor.element.removeEventListener('keydown', handleKeyDown);
        observer.disconnect();
      };
    }
  }, []);
  (0, _react.useEffect)(() => {
    const editor = editorRef?.current;
    if (editor) {
      const handleKeyDown = e => {
        switch (e.key) {
          case 'ArrowDown':
            onArrowDown?.();
            e.preventDefault();
            break;
          case 'ArrowUp':
            onArrowUp?.();
            e.preventDefault();
            break;
          case 'Escape':
            onEscape?.();
            e.preventDefault();
            break;
          case 'Enter':
            e.preventDefault();
            onEnter?.();
          default:
            break;
        }
      };
      editor.element.addEventListener('keydown', handleKeyDown);
      return () => {
        editor.element.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [suggestions, selectedSuggestionIndex]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isClient ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      sx: theme => ({
        width: '100%',
        position: 'relative',
        '& .e-richtexteditor .e-rte-content .e-content': {
          height: `${editorHeight - 5}px`,
          minHeight: `${editorHeight - 5}px`,
          background: 'rgb(0 0 0 / 0%)',
          color: theme.palette.text.primary,
          paddingTop: '14px'
        },
        '& .e-richtexteditor, .e-richtexteditor .e-rte-content': {
          background: 'rgb(0 0 0 / 0%)',
          borderRadius: '4px'
        },
        '& .e-richtexteditor .rte-placeholder': {
          color: theme.palette.text.disabled
        },
        '& .e-rte-container': {
          borderRadius: '4px',
          border: `1px solid ${theme.palette.border?.main}`,
          '&:hover': {
            borderColor: theme.palette.text.primary
          },
          '&:focus': {
            border: `2px solid ${theme.palette.primary.main}`
          },
          '&:focus-within': {
            border: `2px solid ${theme.palette.primary.main}`
          }
        },
        '& .gptTag': {
          fontWeight: 'bold',
          textDecoration: 'underline'
        }
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ej2ReactRichtexteditor.RichTextEditorComponent, {
        ref: editorRef,
        value: value,
        height: editorHeight,
        saveInterval: 100,
        autoSaveOnIdle: true,
        change: handleChange,
        placeholder: placeholder,
        actionBegin: handleActionBegin,
        toolbarSettings: {
          enable: false
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ej2ReactRichtexteditor.Inject, {
          services: [_ej2ReactRichtexteditor.HtmlEditor, _ej2ReactRichtexteditor.Toolbar]
        })
      }), endAdornment && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        position: 'absolute',
        zIndex: 5,
        top: 9,
        right: 7,
        children: endAdornment
      })]
    }) : null
  });
}